import { faCommentNodes, faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import i18n from "i18next";
import { useState } from "react";
import {
	useOptionalAiAssistantControllerContext,
} from "src/components/views/ai/assistant/AiAssistantControllerContext.tsx";
import { logError } from "src/errorHandling/errorLogging.ts";

export const SolveErrorWithAiButton = () => {
	const aiAssistantController = useOptionalAiAssistantControllerContext();
	const [isLoading, setIsLoading] = useState(false);
	if (aiAssistantController == null || !aiAssistantController.isEnabled) return null;

	return (
		// Keep this as a raw button because it is rendered inside ErrorDialog, and AsyncButton/AavoButton
		// depend on ErrorDialogContext for error handling.
		<Button
			disabled={isLoading}
			startIcon={<FontAwesomeIcon icon={isLoading ? faSpinnerThird : faCommentNodes} spin={isLoading} />}
			sx={{ textTransform: "none" }}
			variant={"outlined"}
			onClick={async () => {
				setIsLoading(true);
				try {
					await aiAssistantController.askInNewThread(i18n.t("solve_error_with_aavo_ai_prompt"));
				} catch (error) {
					logError(error, "Failed to ask Aavo AI to solve error");
				} finally {
					setIsLoading(false);
				}
			}}
		>
			{i18n.t("solve_error_with_aavo_ai")}
		</Button>
	);
};
